module.exports = __webpack_public_path__ + "assets/img/img69.e15ba32f.png";